import { ArrowRightIconV2, ChevronDownIcon, Flex, Heading, Text, useMatchBreakpoints } from '@pancakeswap/uikit'
import Divider from 'components/Divider'
import { FAQ_TABS } from 'config/index'
import useTheme from 'hooks/useTheme'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'state'
import { GetDataFAQ } from 'state/FAQ'
import { fetchActiveTab, fetchShowSuggest } from 'state/FAQ/actions'
import { motion } from 'framer-motion'
import { ContainerSuggestMobile, ContainerTitleSuggest, CsChevronDownIcon, CsTitleCollaspe } from '../../styled'

const SuggestMobile = () => {
    // ================== VAR ==================
    const { theme } = useTheme()
    const { isMobile } = useMatchBreakpoints()
    // ================== STATE ==================
    const dispatch = useDispatch<AppDispatch>()
    const { activeTab, isShowSuggest } = GetDataFAQ()
    // ================== REDUX ==================
    // ================== FUNCTION ==================
    const handleClick = (value) => {
        dispatch(fetchShowSuggest({isShowSuggest: false}))
        dispatch(fetchActiveTab({ activeTab: value }))
    }
    const handleClickSussgest = (value) => {
        dispatch(fetchShowSuggest({ isShowSuggest: value }))
    }
    // ================== EFFECT ==================
    // ================== RENDER ==================
    const renderContent = () => {
        if (isShowSuggest) {
            return (
                <Flex width="100%" mt="1rem" flexDirection="column" style={{ gap: '1rem' }}>
                    {FAQ_TABS?.map((dt, index) => {
                        return (
                            <Flex width="100%" flexDirection="column" style={{ gap: '0.5rem' }}>
                                <Flex
                                    width="100%"
                                    justifyContent="space-between"
                                    onClick={() => handleClick(dt?.value)}
                                    style={{ cursor: 'pointer' }}
                                >
                                    <ContainerTitleSuggest>
                                        <CsTitleCollaspe color={activeTab === dt?.value ? 'gold' : 'text'}>{dt.name}</CsTitleCollaspe>
                                    </ContainerTitleSuggest>
                                    <Flex justifyContent="flex-end" alignItems="center" width="40px">
                                        <ArrowRightIconV2
                                            color={activeTab === dt?.value ? theme.colors.gold : theme.colors.text}
                                        />
                                    </Flex>
                                </Flex>
                                {index !== FAQ_TABS?.length - 1 && <Divider />}
                            </Flex>
                        )
                    })}
                </Flex>
            )
        }
        return null
    }
    // ================== MAIN ==================

    return (
        <ContainerSuggestMobile isShowSuggest={isShowSuggest}>
            <Flex width="100%" justifyContent="space-between" alignItems="center">
                <Heading scale={isMobile ? "lg" : "xl"}>Gợi ý dành cho bạn</Heading>
                <CsChevronDownIcon isShow={!isShowSuggest} width={32} onClick={() => handleClickSussgest(isShowSuggest ? false : !false)} />
            </Flex>
            {isShowSuggest ? (
                <motion.div
                    initial={{ opacity: 0, height: 0 }}
                    animate={{ opacity: 1, height: '413px' }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.35, ease: 'easeInOut' }}
                >
                    {renderContent()}
                </motion.div>
            ) : (
                <motion.div
                    initial={{ opacity: 1, height: '413px' }}
                    animate={{ opacity: 0, height: 0 }}
                    exit={{ opacity: 0, height: 0 }}
                    transition={{ duration: 0.35, ease: 'easeInOut' }}
                />
            )}
        </ContainerSuggestMobile>
    )
}
export default SuggestMobile
